import { CSSProperties } from 'react';
import { borderRadius } from '../../../theme/borderRadius';
import { colors } from '../../../theme/colors';
import spacing, { isMobileScreen } from '../../../theme/spacing';
import { MODAL_TOP_EMPTY_SPACE_HEIGHT } from '../utils';

const pullerStyles: CSSProperties = {
  display: 'inline-block',
  height: 6,
  width: 30,
  borderRadius: borderRadius.medium,
  background: colors.textGreyMedium,
};

const DrawerPuller = ({
  onClose,
  isFullHeightDrawer,
  fullHeightContainerHeight,
}: {
  onClose: () => void;
  isFullHeightDrawer?: boolean;
  fullHeightContainerHeight?: number;
}) => {
  const Puller = () => {
    if (!isMobileScreen) {
      return null;
    }
    return (
      <div
        style={{
          display: 'flex',
          height: '100%',
          width: '100%',
          alignItems: isFullHeightDrawer ? 'center' : 'flex-end',
          justifyContent: 'center',
          boxSizing: 'border-box',
          paddingTop: 4,
        }}
      >
        <div
          style={{
            ...pullerStyles,
            ...(isFullHeightDrawer
              ? { opacity: 0 }
              : { marginBottom: spacing.xsMedium, opacity: 0.5 }),
          }}
        ></div>
      </div>
    );
  };

  return (
    <div
      onClick={onClose}
      style={{
        height: isFullHeightDrawer ? 0 : MODAL_TOP_EMPTY_SPACE_HEIGHT,
        maxHeight: isFullHeightDrawer ? 0 : MODAL_TOP_EMPTY_SPACE_HEIGHT,
        width: '100%',
        boxSizing: 'border-box',
        position: 'relative',
        background: isFullHeightDrawer ? 'red' : 'transparent',
      }}
    >
      <Puller />
    </div>
  );
};

export default DrawerPuller;
